import dayjs from 'dayjs'
import { Box } from '@mui/material'
import { Tag } from '../Tag'
import React from 'react'

import { IOrder } from '../../types/order'

interface Props {
  order: IOrder
}

const FacebookTag = (props: Props) => {
  const { order } = props
  return (
    <>
      {order.referrer?.platform === 'facebook' && (
        <Box py={0.5} display={'flex'} flexWrap={'wrap'} gap={1}>
          <Tag color={`info`}>Facebook Chat</Tag>
        </Box>
      )}
    </>
  )
}

export default FacebookTag
